import React, { useEffect, useState } from 'react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { Pie } from '@ant-design/plots';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
const { Option } = Select;

const PieChart = ({
  deviceNameArr,
  deviceTable,
  deviceIndex,
  tableName,
  onDevice,
  onUnit,
}) => {
  const [searchStartDate, setSearchStartDate] = useState(
    moment().startOf('month').valueOf()
  );
  const [searchEndDate, setSearchEndDate] = useState(
    moment().endOf('month').add(1, 'day').valueOf()
  );
  const [DeviceName, setDeviceName] = useState([]);
  const [filter, setFilter] = useState({
    timeStart: searchStartDate,
    timeEnd: searchEndDate,
    unit: 'day',
    chartType: 'pieChart',
    tableName,
  });
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (deviceTable && deviceIndex) {
      const NameArr = [];
      deviceTable.map((item) => {
        const database = client.service(item);
        database
          .find({})
          .then((res) => {
            res.data.map((dataset) => NameArr.push(dataset[deviceIndex]));
            const filteredArray = NameArr.filter(function (ele, pos) {
              return NameArr.indexOf(ele) === pos;
            });
            setDeviceName(filteredArray);
          })
          .catch((error) => {
            console.log(error);
          });
        return true;
      });
    }
    if (deviceNameArr) {
      setDeviceName(deviceNameArr);
    }
  }, [deviceTable, deviceIndex, deviceNameArr]);

  useEffect(() => {
    let str = '';
    // for (const key in filter) {
    //   str += `${key}=${filter[key]}&`;
    // }
    Object.keys(filter).forEach((key) => {
      str += `${key}=${filter[key]}&`;
    });
    console.log(str);
    axios(`/ezcon/api/efficacyStatisticChart?${str}`, {
      method: 'GET',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
      // data: newRecord,
    })
      .then((res) => {
        console.log(res);
        setChartData(res.data);
        //   Message.success('資料更新成功並發佈至公播盒');
      })
      .catch((err) => {
        console.log(err);
        //   Message.error(err);
      });
  }, [filter]);
  const config = {
    data: chartData,
    angleField: 'value',
    colorField: 'type',
    radius: 0.9,
    // label: {
    //   type: 'inner',
    //   offset: '-30%',
    //   content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
    //   style: {
    //     fontSize: 14,
    //     textAlign: 'center',
    //   },
    // },
    label: {
      type: 'outer',
      content: '{name} {percentage}',
      style: {
        fontSize: 14,
      },
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
  };

  return (
    <>
      <div>
        <div className={styles.FilterTitle}>
          時間：
          {onUnit && (
            <Select
              value={filter.unit}
              onChange={(value) => {
                const newFilter = { ...filter };
                newFilter.unit = value;
                setFilter(newFilter);
              }}
            >
              <Option value="hour">小時</Option>
              <Option value="day">日</Option>
              <Option value="month">月</Option>
              <Option value="year">年</Option>
            </Select>
          )}
          {filter.unit === 'hour' ? (
            <DatePicker
              defaultValue={moment().format('YYYY-MM-DD')}
              onChange={(value) => {
                const newFilter = { ...filter };
                newFilter.timeStart = moment(value).valueOf();
                newFilter.timeEnd = moment(value).valueOf();
                setFilter(newFilter);
              }}
            />
          ) : (
            <RangePicker
              picker={filter.unit}
              defaultValue={[
                moment().startOf('month'),
                moment().endOf('month'),
              ]}
              onChange={(value) => {
                setSearchStartDate(moment(value[0]).format('YYYY-MM-DD'));
                setSearchEndDate(moment(value[1]).format('YYYY-MM-DD'));
                const newFilter = { ...filter };
                newFilter.timeStart = moment(value[0]).valueOf();
                newFilter.timeEnd = moment(value[1]).add(1, 'days').valueOf();
                setFilter(newFilter);
              }}
            />
          )}
        </div>
        {onDevice && (
          <div className={styles.FilterTitle}>
            類型：
            <Select
              value={filter.deviceName}
              style={{ width: 120 }}
              showSearch
              placeholder="請選擇"
              onChange={(value) => {
                const newFilter = { ...filter };
                if (value !== '全部') {
                  newFilter.deviceName = value;
                  newFilter.deviceTitle = deviceIndex;
                } else {
                  delete newFilter.deviceName;
                  delete newFilter.deviceTitle;
                }
                setFilter(newFilter);
              }}
            >
              <Option value="">全部</Option>
              {DeviceName.map((x) => (
                <Option value={x}>{x}</Option>
              ))}
            </Select>
          </div>
        )}

        <div style={{ marginTop: 40 }}>
          <Pie {...config} />
        </div>
      </div>
    </>
  );
};

export default PieChart;
